<template>
    <div class="container-fluid" id="about" v-if="show">
        <div class="eyecatch">
            <img src="/img/about/02.jpg" alt="アイキャッチ・小説を書く" class="img-fluid mx-auto d-block about" />
        </div>
        <div class="container mincho">
            <links></links>
            <h2 class="text-center" id="write">
                <i class="fas fa-pen-fancy"></i>
                小説を書く
            </h2>
            <div class="desc">
                <p>
                    ユーザー登録し、作者様専用のサブドメインを取得したら、すぐに小説を書き始められます。
                    貸し本棚の小説管理機能と執筆用のエディタは、小説を書くことに特化した機能を備えています。
                </p>
            </div>
            <h3 class="text-center">
                強力な執筆機能
            </h3>
            <div class="row my-2">
                <div class="col-md-4">
                    <h5 class="small-caption">ルビをふる</h5>
                    <img v-lazy="'/img/about/w01.png'" alt="ルビボタン" class="img-fluid img-desc img-tips mx-auto d-block" />
                    <div class="mt-2">
                        執筆中にルビを振りたいとき、ルビの対象になる文字列を選択し、
                        ツールバーのボタンをタップするか、ショートカットを入力することで、
                        ルビ文字を自動入力し、即座に読み仮名を入力することができます。<br>
                        また、本文は自動保存され、万が一保存を忘れてページを離脱したり、
                        ブラウザを閉じてしまっても、それまで執筆した文章が失われることはありません。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">検索と置換</h5>
                    <img v-lazy="'/img/about/w02.png'" alt="検索と置換" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        検索ボタンから検索ウインドウを表示すると、指定した文字列を、執筆中の本文だけでなく、
                        <b>その作品全体から探し出し</b>、一覧化します。
                        この一覧から指定箇所へ遷移することができます。
                        一覧はウインドウを閉じても消えることは有りません。<br>
                        指定の文字列を一括で置換することができます。
                        登場人物の名前変更など、ありがちで手間のかかる修正が一瞬で完了します。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">ツール</h5>
                    <img v-lazy="'/img/about/w03.png'" alt="メニュー" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        スマホのための字下げや実画面プレビュー、打鍵音設定などの執筆を助ける機能があります。
                        PCで執筆している場合は、Ctrl+S(⌘+S)で保存できます。<br>
                        一つのエピソードが長すぎた場合、カーソルの指定位置で二つのエピソードに分解することができます。
                        また、その逆に、次のエピソードと糾合することもできます。
                    </div>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-md-4">
                    <h5 class="small-caption">ノート機能</h5>
                    <img v-lazy="'/img/about/w04.png'" alt="ノート" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        小説の梗概を第一話に書いてますか？<br>
                        貸し本棚は梗概や登場人物、設定資料などのノートを本文とは個別に保存し、
                        執筆中のエディタに並べて使うことができます。
                        このノートはいつでも編集でき、ノート全体に対して指定文字列を一括置換することもできます。
                        見出しの書式を記述すれば、アウトライン一覧にリストし、見出しにジャンプすることが可能です。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">目次</h5>
                    <img v-lazy="'/img/about/w05.png'" alt="目次" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        執筆中に、以前のエピソードに戻って確認したり、修正したいとき、
                        エピソード一覧に戻らずとも、エディタ画面で編集するエピソードを即座に切り替えることができます。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">執筆ライブ</h5>
                    <img v-lazy="'/img/about/w06.png'" alt="ライブ" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        貸し本棚の奇妙な機能のひとつが「ライブ配信」です。<br>
                        ライブ配信を開始すると、ライブ画面が別のタブに開きます。
                        このタブのURLをSNSなどで告知することで、執筆作業をライブ配信することができます。<br>
                        ライブ画面は実際の公開レイアウトに近い形で表示されますので、
                        縦書きの確認のために使うこともできます。
                    </div>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-md-4">
                    <h5 class="small-caption">順番を変える</h5>
                    <img v-lazy="'/img/about/w07.png'" alt="ソート" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        エピソードの順番は容易に変更できます。
                        章を追加した場合も、エピソードと同じ感覚で順番を変更することができます。
                        大量のエピソードがある場合でも、指定エピソードを指定位置へワンクリックで移動できます。
                        悩むところは全くありません。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">公開日を一括設定</h5>
                    <img v-lazy="'/img/about/w08.png'" alt="一括公開日" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        百話を超える大作の公開日設定は大変な作業で、ミスによってテレコに公開されてしまうリスクを伴います。
                        貸し本棚では前のエピソードを後のエピソードより過去の公開日時に設定することはできません。
                        第一話の公開日時を設定し、一定間隔でそれ以降のエピソードの公開日を一括設定することができます。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">アップロード</h5>
                    <img v-lazy="'/img/about/w09.png'" alt="アップロード" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        規程のフォーマットの準拠したテキストファイルをアップロードすることで、
                        既存作品を一括登録することができます。
                        「小説家になろう」や「カクヨム」、あるいは「貸し本棚」自身の出力フォーマットであれば、
                        自動解析機能によって無加工でインポートすることができます。
                    </div>
                </div>
            </div>
            <h3 class="my-5 text-center">
                <ruby>未完<rt>エタ</rt></ruby>る作品とはさよなら
            </h3>
            <div class="row my-2">
                <div class="col-md-5">
                    <img v-lazy="'/img/about/w10.png'" alt="執筆実績" class="img-fluid img-desc mx-auto d-block" />
                    <div class="text-muted small">
                        50万字の大作もあと少し……（ユーザー様提供実データ）
                    </div>
                </div>
                <div class="col-md-7">
                    <p>
                        Web作家にとって、作品を未完のまま放棄してしまうのは最も憂慮すべき問題です。
                        作品が完結できない原因は大きく分けて５つあります。
                    </p>
                    <ol>
                        <li>モチベーションの低下</li>
                        <li>時間管理の難しさ</li>
                        <li>批評や批判に対する恐れ</li>
                        <li>ストーリーラインの迷い</li>
                        <li>計画の欠如</li>
                    </ol>
                    <p>
                        この中で、計画の欠如と時間管理の難しさについて、貸し本棚の機能が助けになります。
                    </p>
                    <h4>プロット機能</h4>
                    <p>
                        作品の梗概を書き上げたら、最終話までのエピソードタイトルを最初に一気に作ってしまうことができます。
                        タイトルだけの空の本文のリストが作られ、それらひとつひとつに何を書くかについて簡単なあらすじを１４０字以内で記述できます。
                        この機能によって<b>進捗状況が明確に見える</b>ようになります。
                    </p>
                    <p>
                        予想外のエピソードの増減があっても心配ありません。
                        貸し本棚は本文を指定位置で分解したり、次のエピソードと結合することができます。
                    </p>
                    <h4>執筆実績機能</h4>
                    <p>
                        実際に執筆を開始すると、日々の執筆量を記録してグラフ化し、あなたの執筆パフォーマンスを計測します。
                        プロット機能によってエピソードを事前に追加していた場合、エピソード単位の平均文字数から完成までのロードマップを計測します。
                        パフォーマンス維持のために、あと何文字執筆すれば良いかをリアルタイムで表示します。
                        この機能によって、大作であっても無理なく完結を目指すことができます。
                    </p>
                    <p>
                        執筆実績の数値はあなたの実績に基づいて再計算されるため、
                        表示された数値を維持するために脅迫的なペナルティを課すことはありません。
                        日常生活やその時の調子によってパフォーマンスが落ちると、それに伴ってノルマは減少し、
                        逆に調子が上がるとノルマは増えていき、完結予定日数は短縮されます。
                    </p>
                </div>
            </div>
            <div class="mt-5">
                <links></links>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.about {
    max-height: 640px;
}
.eyecatch {
    background-color: #E6E7E2;
}
.desc {
    font-size: 1.1rem;
    margin-bottom: 2.5rem;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
}
.caption {
    margin: 3rem 0 .8rem;
    padding: .5rem 0;
    border-bottom: 1px dashed #ddd;
}
.img-desc {
    border: 1px solid #ddd;
    border-radius: .2rem;
}
.img-tips {
    width: 350px;
    height: 350px;
}
.img-icon {
    object-fit: cover;
    width: 64px;
    height: 64px;
}
.icon-column {
    max-width: 64px;
}
.small-caption {
    font-weight: bold;
    text-align: center;
    margin-top: 2rem;
}
#about {
    padding-right: 0px;
    padding-left: 0px;
    h2 {
        margin-top: 5rem;
        margin-bottom: 1rem;
    }
}
</style>

<script>
import links from "./links";
export default {
    components: {
        links
    },
    data() {
        return {
            show: true
        }
    },
    mounted() {
        this.useHead({
            title: "小説を書く | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>